import { createSlice } from "@reduxjs/toolkit";

const CreateCartSlice = (name) => {
  const initialState = {
    items: [],
  };

  return createSlice({
    name,
    initialState,
    reducers: {
      addItemToCart: (state, action) => {
        const existingItemIndex = state.items.findIndex(
          (item) => item.KOTSEQCODE === action.payload.KOTSEQCODE
        );

        if (existingItemIndex >= 0) {
          state.items[existingItemIndex].quantity += 1;
        } else {
          state.items.push({ ...action.payload, quantity: 1 });
        }
      },
      updateItemAddons: (state, action) => {
        const { KOTSEQCODE, addons } = action.payload;
        const itemIndex = state.items.findIndex(
          (item) => item.KOTSEQCODE === KOTSEQCODE
        );

        if (itemIndex >= 0) {
          state.items[itemIndex].addons = addons;
        }
      },

      removeItemFromCart: (state, action) => {
        state.items = state.items.filter(
          (item) => item.KOTSEQCODE !== action.payload
        );
      },
      increaseItemQuantity: (state, action) => {
        const itemIndex = state.items.findIndex(
          (item) => item.KOTSEQCODE === action.payload
        );

        if (itemIndex >= 0) {
          state.items[itemIndex].quantity += 1;
        }
      },
      decreaseItemQuantity: (state, action) => {
        const itemIndex = state.items.findIndex(
          (item) => item.KOTSEQCODE === action.payload
        );

        if (itemIndex >= 0 && state.items[itemIndex].quantity > 1) {
          state.items[itemIndex].quantity -= 1;
        }
      },
      updateItemQuantity: (state, action) => {
        const { itemId, quantity } = action.payload;
        const itemIndex = state.items.findIndex(
          (item) => item.KOTSEQCODE === itemId
        );

        if (itemIndex >= 0) {
          state.items[itemIndex].quantity = quantity;
        }
      },
      updateItemRate: (state, action) => {
        const { itemId, rate } = action.payload;
        const itemIndex = state.items.findIndex(
          (item) => item.KOTSEQCODE === itemId
        );

        if (itemIndex >= 0) {
          state.items[itemIndex].RATE = rate;
        }
      },
      clearCart: (state) => {
        state.items = [];
      },
    },
  });
};

export default CreateCartSlice;
